/**
 * Admin-side deposit release — for a decision the representative gave by phone.
 *
 * Mounts the same panel the representative sees at /deposit-release/:token, in
 * English. The endpoint records the acting admin as the decider, so the refund
 * statement says who entered it rather than implying the representative filled
 * this in themselves.
 *
 * The panel and its fetch live in AdminDepositRelease, shared with the inline
 * copy in the Move-out tab. This file is now only the dialog framing: the two
 * entry points cannot drift apart in validation or maths.
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AdminDepositRelease } from "./AdminDepositRelease";
import type { DepositReleaseLogEvent } from "@/lib/depositReleaseApi";

export function SettleDepositDialog({
  open,
  onOpenChange,
  settlementId,
  onReleased,
  onLog,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  settlementId: string | null;
  /** Called once a decision is recorded, so the profile can refetch. */
  onReleased?: () => void;
  /** Told what the panel's action actually did, for the caller to audit-log. */
  onLog?: (event: DepositReleaseLogEvent) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        style={{
          maxWidth: 760,
          maxHeight: "88vh",
          overflowY: "auto",
          padding: 0,
        }}
      >
        <DialogHeader style={{ padding: "22px 24px 8px" }}>
          <DialogTitle style={{ fontSize: 17, fontWeight: 700 }}>
            Settle the deposit
          </DialogTitle>
          <DialogDescription style={{ fontSize: 13, color: "#64748B" }}>
            For a decision the representative gave by phone. It is recorded
            under your name, not theirs.
          </DialogDescription>
        </DialogHeader>

        <div style={{ padding: "0 24px 24px" }}>
          <AdminDepositRelease
            settlementId={settlementId}
            active={open}
            onReleased={onReleased}
            onLog={onLog}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
